import React from 'react';
import {
  ListItem, InputField,
} from 'vindi-ds-components';
import selectData from '../create/templates/select_per_unit';

function ListProducts() {
  return (
    <InputField
      select
      size='medium'
      name='unit'
      placeholder='Preencha a medida'
    >
      {selectData.map((data) => (
        <ListItem key={data.value} value={data.value}>
          {data.value}
        </ListItem>
      ))}
    </InputField>
  );
}

export default ListProducts;
